import Api from "./api";

export default class OccupancyApi extends Api {
    constructor(token, clientId, onUnathourized) {
        super(token, clientId, onUnathourized);
        this.baseUrl = this.getBaseUrl() + "occupancy/";
    }

    getOccupancyTrends(
        facility,
        fromDate,
        toDate,
        onSuccess,
        onError,
        timeAgg,
        locations = [],
        systems = []
    ) {

        const endPoint = this.baseUrl + "trends/";

        let data = {
            facility: facility ? facility.split("/").slice(-2)[0] : undefined,
            from_date: fromDate.toISOString().split("T")[0],
            to_date: toDate.toISOString().split("T")[0],
            time_agg: timeAgg,
        };

        if (locations.length > 0) data["location"] = locations;
        if (systems.length > 0) data["system"] = systems;

        this.Post(endPoint, data, onSuccess, onError);
    }
}
